import { useQuery } from '@tanstack/react-query';
import { fetchTemplateAssignments } from '../services/templateAssignments';
import { templateAssignmentKeys } from './templateAssignmentKeys';

export const ASSIGNMENTS_PAGE_SIZE = 100;

export const useTemplateAssignmentsQuery = (productId: string) =>
  useQuery({
    queryKey: templateAssignmentKeys.forProduct(productId),
    queryFn: () => fetchTemplateAssignments({ productId, perPage: ASSIGNMENTS_PAGE_SIZE }),
    enabled: Boolean(productId),
  });
